import {
  campaignCreationParametersSchema,
  populatedCampaignSchema,
} from "@redotech/redo-marketing-common/campaigns/campaign-definition";

export const createCampaign = {
  name: "createCampaign" as const,
  description:
    "Create a campaign with its channel, name, and (for email) subject line + preview text. This only creates the shell — follow up with updateCampaign to set the email/SMS template content, target audience, and schedule. Build the audience first with createDynamicSegment, or pick an existing one with fetchTeamSegments.",
  mutates: true,
  input: campaignCreationParametersSchema,
  output: populatedCampaignSchema,
};
